
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 406 197","fill":"none","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMinYMin slice","aria-hidden":"true","focusable":"false"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#115AA5","d":"M.156 0h405v197h-405z"}}),_c('g',{attrs:{"opacity":".25"}},[_c('path',{attrs:{"d":"M304.172-75.094L175.223-.49l128.949 74.585V-75.094z","fill":"#B8C9DE"}}),_c('path',{attrs:{"d":"M304.172-75.094V74.093L433.121-.51v-149.187L304.172-75.094z","fill":"#004F9B"}}),_c('path',{attrs:{"d":"M433.121-.51L304.172 74.093l128.949 74.603 128.93-74.603L433.121-.51z","fill":"#106CA4"}}),_c('path',{attrs:{"d":"M175.223-.51L46.293 74.093l128.93 74.603 128.949-74.603L175.223-.51z","fill":"#106CA4"}}),_c('path',{attrs:{"d":"M46.293 223.3l128.93-74.603-128.93-74.603V223.3z","fill":"#7598C1"}}),_c('path',{attrs:{"d":"M175.223 148.697L46.293 223.3l128.93 74.603V148.697z","fill":"#B8C9DE"}}),_c('path',{attrs:{"d":"M175.223 148.697v149.206L304.172 223.3V74.094l-128.949 74.603z","fill":"#004F9B"}}),_c('path',{attrs:{"d":"M304.172 223.3l128.949 74.603V148.697L304.172 223.3z","fill":"#B8C9DE"}}),_c('path',{attrs:{"d":"M433.121 148.697L304.172 74.094V223.3l128.949-74.603z","fill":"#7598C1"}})])])
          )
        }
      }
    